<!--公用组件：弹框
      /**
      * @desc 组件描述
      * @param {Boolean} [visible] - 控制弹框显示
      * @param {String} [title] - 弹框标题
      * @param {String} [tip] - 底部说明
      * @param {fun} [confirmCallback] - 确认按钮回调
      * @example 调用示例
      *  <Modal :visible.sync="tempModal"
      *      :title="'标题'"
	    *		   :tip="'已拥有unique商品提示'"
	    *		   :cancelTxt="'取消'"
	    *		   :confirmTxt="'确认'"
      *      :mask-closable="true"
	    *		   @confirmCallback="tempModalcallback">
	    *		   <div slot="content">
	    *		   </div>
	    *	</Modal>
      */
-->
<template>
  <div class="modal" v-if="visible">
    <div class="modal-container fadeInUp animated">
      <div class="modal-header" v-if="title">
        <span>{{ title }}</span>
      </div>
      <div class="modal-main">
        <slot name="content"></slot>
      </div>
      <div class="modal-footer">
        <button @click="cancel" class="cancel" v-if="cancelTxt">{{ cancelTxt }}</button>
        <button @click="confirm" class="confirm" v-if="confirmTxt">{{ confirmTxt }}</button>
      </div>
      <div class="modal-tip" v-if="tip">
        <span>{{ tip }}</span>
      </div>
      <i @click="close" class="modal-close"></i>
    </div>
    <div class="modal-mask" @click="maskClose"></div>
  </div>
</template>

<script>
export default {
    name: 'modal',
    props: {
        visible: {
            type: Boolean,
            default: false
        },
        title: {
            type: String,
            default: ""
        },
        tip: {
            type: String,
            default: ""
        },
        cancelTxt: {
            type: String,
            default: ""
        },
        confirmTxt: {
            type: String,
            default: ""
        },
        maskClosable: {
            type: Boolean,
            default: false
        }
    },
    data(){
        return{
            
        }
    },
    methods: {
        // 点击遮罩关闭
        close(){
            this.$emit('update:visible',false)
        },
        cancel(){
            this.close()
        },
        confirm(){
            if(this.$listeners.confirmCallback){
                this.$emit("confirmCallback")
            }else{
                this.close()
            }
        },
        maskClose(){
            if(!this.maskClosable) return
            this.close()
            
        }
    }
}
</script>
<style src="../../static/css/index.css"></style>
<style lang="scss">
.modal {
  width: 100vw;
  height: 100vh;
  position: absolute;
  left: 0;
  top: 0;
  overflow: hidden;
  z-index: 100;
}

.modal-container {
  position: absolute;
  top: 50%;
  left: 50%;
  z-index: 101;
  @include res-size($width: 860px, $height: 485px);
}

.modal-header {
  text-align: center;
  @include res-size(
    $height: 115px,
    $font-size: 30px
  );
}

.modal-main {
  text-align: center;
  @include res-size($padding-top: 30px, $padding-bottom: 30px, $height: 250px);

  div p span{
    font-family: inherit !important;
  }

}

.modal-mask {
  width: 100%;
  height: 100%;
  top: 0;
  bottom: 0;
  left: 0;
  top: 0;
  position: fixed;
  background-color: #000;
  opacity: 0.7;
}

.modal-footer {
  display: flex;
  justify-content: center;
}

.modal-footer button {
  color: #fff;
  min-width: px2vh(200px);
  padding: 0 px2vh(30px);
  height: px2vh(65px);
  line-height: px2vh(65px);
  font-size: px2vh(30px);
  margin: 0 px2vh(30px);
}

.modal-footer .confirm {
  // background-color: #000;
}

.modal-footer .cancel {
  // background-color: #666;
}

.modal-tip {
  text-align: center;
  display: table;
  width: 100%;
  padding: 0 px2vh(15px);
  @include res-size($margin-top: 10px, $height: 50px, $font-size: 20px);
}

.modal-tip span {
  display: table-cell;
  vertical-align: middle;
  text-align: center;
}

.modal-close {
  position: absolute;
  left: 0;
  color: #fff;
  background-image: url(../../static/images/close.png);
  background-size: 100% 100%;
  @include res-size($width: 66px, $height: 66px, $top: -79px);
}
</style>



// WEBPACK FOOTER //
// src/components/common-components/features/modal/index.vue